var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/components/itemPropsCtx.tsx";
import React from 'react';
import { useStore } from 'effector-react';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var ItemPropsCtx = /*#__PURE__*/React.createContext(null);
export var useItemProps = function useItemProps() {
  var props = React.useContext(ItemPropsCtx);
  return props;
};
export var useCtxData = function useCtxData() {
  var _useItemProps = useItemProps(),
      currentUserClassifier$ = _useItemProps.currentUserClassifier$,
      onClickNode = _useItemProps.onClickNode,
      isSelected = _useItemProps.isSelected,
      seoEventManager = _useItemProps.seoEventManager,
      activeEstimation = _useItemProps.activeEstimation,
      estimationId = _useItemProps.estimationId;

  var currentClassifierData = useStore(currentUserClassifier$);
  return React.useMemo(function () {
    return {
      currentClassifierData: currentClassifierData,
      onClickNode: onClickNode,
      isSelected: isSelected,
      seoEventManager: seoEventManager,
      estimationId: estimationId,
      activeEstimation: activeEstimation
    };
  }, [currentClassifierData, onClickNode, isSelected, seoEventManager, estimationId, activeEstimation]);
};